import { render, staticRenderFns } from "./AdvisoryForm.vue?vue&type=template&id=e23f70cc&scoped=true&"
import script from "./AdvisoryForm.vue?vue&type=script&lang=js&"
export * from "./AdvisoryForm.vue?vue&type=script&lang=js&"
import style0 from "./AdvisoryForm.vue?vue&type=style&index=0&id=e23f70cc&scoped=true&lang=css&"
import style1 from "./AdvisoryForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f70cc",
  null
  
)

export default component.exports